import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHistoryRewind = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 3C7.03 3 3 7.03 3 12H1L3.89 15.89L3.96 16.03L7 12H5C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19C10.07 19 8.32 18.21 7.06 16.94L5.64 18.36C7.27 19.99 9.51 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM11 8V13L15.25 15.52L16.02 14.24L12.5 12.15V8H11Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgHistoryRewind);
export { ForwardRef as ReactComponent };
